import { ImageSafetyTag } from '../types/Image';

const safetyTagDescriptions: Partial<Record<ImageSafetyTag, string>> = {
  anatomy:
    'Cadaveric dissections or gross organ specimens (e.g., cross-sectioned hearts, lungs, brains)',
  graphic:
    'Graphic photos showing wounds, burns, surgical procedures, skin lesions, self-harm, or other potentially distressing medical imagery',
  nudity:
    'Clinical photos showing exposed private anatomy (genitalia, breasts, buttocks)',
  pediatric:
    'Sensitive photos involving infants or children, including undressed patients, visible deformities, or distressing clinical presentations',
};

export const getSensitiveContentTooltipText = (
  nsfw: ImageSafetyTag[]
): string | undefined => {
  const descriptions = nsfw
    .map((tag) => safetyTagDescriptions[tag])
    .filter(Boolean);

  if (descriptions.length === 0) return undefined;

  return descriptions.join('\n\n');
};
